<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col mt-8 mb-4">
    <!-- <p-datepicker [(ngModel)]="updateDate" [numberOfMonths]="3" [autofocus]="true" /> -->
    <p-floatlabel style="width: 300px">
      <p-datepicker [(ngModel)]="updateDate" [numberOfMonths]="3" [autofocus]="true" inputId="over_label" />
      <label for="over_label">Set Manufacturer Ship Date:</label>
    </p-floatlabel>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="!(isPageReady && okToUpdate())" (click)="ok()" pButton type="button" class="p-button-raised">
      Proceed with Update
    </button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
